<template>
  <div class="pdf">
    <iframe
      :src="`/static/pdf/web/viewer.html?file=${encodeURIComponent(src)}`"
      frameborder="0"
      style="width: 100%; height: calc(100vh)"
    ></iframe>
  </div>
</template>

<script>
import {getBookInfo} from '../../api'
export default {
  data() {
    return {
      src: "",
      loading: false,
    };
  },
  created() {
    this.loadBook();
  },
  methods: {
    getPdfCode: function () {
      this.loading = true;
      this.src = "https://www.letmecode.cn/api/" + "web/book/read?id=" + this.$route.params.bookId;
      // this.src = `https://blog-1307106730.cos.ap-shanghai.myqcloud.com/${this.$route.params.bookId}.pdf`
    },
    // 禁用鼠标右击、F12 来禁止打印和打开调试工具
    prohibit() {
      document.oncontextmenu = function (ev) {
        return false; //屏蔽右键菜单
      };
      document.onkeydown = function (e) {
        if (
          e.ctrlKey &&
          (e.keyCode === 65 ||
            e.keyCode === 67 ||
            e.keyCode === 73 ||
            e.keyCode === 74 ||
            e.keyCode === 80 ||
            e.keyCode === 83 ||
            e.keyCode === 85 ||
            e.keyCode === 86 ||
            e.keyCode === 117)
        ) {
          return false;
        }
        if (e.keyCode === 18 || e.keyCode === 123) {
          return false;
        }
      };
    },
    loadBook() {
        getBookInfo(this.$route.params.bookId).then(res => {
          if (res.data.size != 0) {
            let lst = localStorage.getItem("localList");

            let data = {
              name: res.data.name,
              id: res.data.id,
              type: res.data.type,
              last: new Date()
            }

            if (lst == null){
              let newLst = [];
              newLst.push(data);
              localStorage.setItem("localList", JSON.stringify(newLst));
            }else{
              let oldLst = JSON.parse(lst);

              let objectExists = false;

              if (oldLst.length > 5){
                oldLst.pop();
              }

              oldLst.forEach((item) => {
                  if (item.id === data.id) {
                      objectExists = true;
                      item.last = data.last;
                  }
              });

              if (!objectExists) {
                oldLst.push(data);
              } 
              oldLst.sort((a, b) => new Date(b.last) - new Date(a.last));
              localStorage.setItem("localList", JSON.stringify(oldLst));
            }
          } 
        })
      }
  },
  mounted() {
    this.$nextTick(() => {
      this.getPdfCode();
    });
  },
};
</script>

<style lang="scss" scoped></style>
